import { NotImplementedField } from "../Form/formComponents/NotImplementedField";
import type { FormFieldFactoryProps } from "../Form/types/types";
import { EditableListFormFieldsMap } from "./EditableListFormFieldsFactory";
import type { EditableListFormComponent } from "./types/EditableListFormComponent";

export const createEditableListFormField = (props: FormFieldFactoryProps) => {
    const field = EditableListFormFieldsMap[props.field.component as unknown as EditableListFormComponent] || NotImplementedField;
    return field(props);
};
